module.exports = __webpack_public_path__ + "static/media/18-1.689579b7.mp3";